import React, { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useFlags } from "@/hooks/useFlags";

/** Voorstel 36 p7: na een release één keer 'Wat is nieuw' tonen (per versie, per browser). */
export default function WatIsNieuw() {
  const { aan } = useFlags();
  const [d, setD] = useState(null);
  const flagAan = aan("bedrijfszekerheid_v1");
  useEffect(() => {
    if (!flagAan) return;
    if (localStorage.getItem("bpt_versie_gezien") === "alles") return;
    api.get("/release/wat-is-nieuw").then((r) => {
      window.__bptVersie = r.data.versie?.versie;
      if (!r.data.tonen || !r.data.items?.length) return;
      const gezien = localStorage.getItem("bpt_versie_gezien");
      if (gezien !== r.data.versie.versie) setD(r.data);
    }).catch(() => {});
  }, [flagAan]);
  if (!d) return null;
  const sluit = () => { localStorage.setItem("bpt_versie_gezien", d.versie.versie); setD(null); };
  return (
    <Dialog open onOpenChange={(v) => !v && sluit()}>
      <DialogContent className="max-w-lg" data-testid="wat-is-nieuw">
        <DialogHeader><DialogTitle className="flex items-center gap-2"><Sparkles className="w-4 h-4 text-amber-500" /> Wat is nieuw in BPTplus</DialogTitle><DialogDescription className="text-xs">versie {d.versie.versie}</DialogDescription></DialogHeader>
        <div className="space-y-2 text-sm max-h-[60vh] overflow-auto">{d.items.slice(0, 3).map((r) => <div key={r.titel}><div className="font-medium text-xs text-slate-500">{r.titel}</div><ul className="list-disc ml-5 text-xs">{r.punten.map((p) => <li key={p}>{p}</li>)}</ul></div>)}</div>
        <div className="flex justify-end"><Button size="sm" onClick={sluit} data-testid="wat-is-nieuw-sluiten">Begrepen</Button></div>
      </DialogContent>
    </Dialog>
  );
}
